export const SET_EDIT_USER_DETAILS_LOADED = "SET_EDIT_USER_DETAILS_LOADED";

export const setEditUserDetailsLoaded = (editUserDetailsLoaded: boolean) => {
  return {
    editUserDetailsLoaded,
    type: SET_EDIT_USER_DETAILS_LOADED
  };
};
